import { getSelectedOnBehalfOfUserId } from '@ms/yammer-data/dist/domains/analyticsSettings/selectors';

import { useSelector } from '../useSelector';

type UseSelectedOnBehalfOfUserId = () => ReturnType<typeof getSelectedOnBehalfOfUserId>;
export const useSelectedOnBehalfOfUserId: UseSelectedOnBehalfOfUserId = () => useSelector(getSelectedOnBehalfOfUserId);
